export const presetCaption =
  'Full Access first month £5, then £11.99 per month, cancel at any time'

export const presetTestCaption =
  'Full Access first month £5, then £11.99 per month, cancel at any time'

export const presetButtonText = 'Subscribe to Which?'

export const presetHref = 'https://join.which.co.uk'
